export const environment = {
  base_url: process.env.REACT_APP_base_url,
  GEOSERVER_URL: process.env.REACT_APP_GEOSERVER_URL,
};
